<script>
  
  /**
   * @typedef {Object} Props
   * @property {string} [id] - import { onMount } from "svelte";
   * @property {string} [stroke]
   * @property {string} [fill]
   * @property {string} [height]
   * @property {string} [width]
   * @property {string} [role]
   */

  /** @type {Props} */
  let {
    id = "",
    stroke = "",
    fill = "#8c8c8c",
    height = "",
    width = "",
    role = "presentation"
  } = $props();
  let icons_url = "/Assets/Project/Website/images/icons.svg";
  // onMount(() => {
  //   let cdn_container = document.getElementById("content");
  //   if (cdn_container && cdn_container.dataset.cdn) {
  //     icons_url = `${cdn_container.dataset.cdn}images/icons.svg${
  //       "/" + cdn_container.dataset.version ? cdn_container.dataset.version : ""
  //     }`;
  //   }
  // });
</script>

<svg {fill} {stroke} {height} {width} {role}>
  <use href={icons_url + id} />
</svg>
